//  POEdit.aspx -> Quick Receive Stock
var InitQuickReceiveModal = function (poEdit, $) {
    poEdit.QuickReceiveModal = (function () {
        const ModalSelector = '#quick_receive_modal'
        var SubmitBtnSelector = '#quick_receive_btn_submit'
        const AccessDeniedModalSelector = '#access_restricted_modal'

        // Confirmation modal selectors
        const ConfirmationModalSelector = '#quick_receive_confirmation_modal'
        const ConfirmationSINumberWarningSelector = '#quick_receive_confirmation_siNumber'
        const ConfirmationSIDateWarningSelector = '#quick_receive_confirmation_siDate'
        const ConfirmationModalCancelBtnSelector = '#quick_receive_confirmation_cancel'
        const ConfirmationModalSubmitBtnSelector = '#quick_receive_confirmation_submit'

        const TotalSupplierBuyExTaxSelector = '#lbl_total_supplierbuy_ex_tax'
        const TotalSupplierBuyIncTaxSelector = '#lbl_total_supplierbuy_inc_tax'
        const TotalSupplierBuyTaxSelector = '#lbl_total_supplierbuy_tax'

        const TotalFreightExSelector = '#lbl_freight_ex_tax'
        const TotalFreightIncSelector = '#lbl_freight_inc_tax'
        const TotalFreightTaxSelector = '#lbl_freight_tax'

        const TotalDutyExSelector = '#lbl_duty_ex_tax'
        const TotalDutyIncSelector = '#lbl_duty_inc_tax'
        const TotalDutyTaxSelector = '#lbl_duty_tax'

        const TotalMiscExSelector = '#lbl_misc_ex_tax'
        const TotalMiscIncSelector = '#lbl_misc_inc_tax'
        const TotalMiscTaxSelector = '#lbl_misc_tax'

        const TotalExSelector = '#lbl_total_ex_tax'
        const TotalIncSelector = '#lbl_total_inc_tax'
        const TotalTaxSelector = '#lbl_total_tax'

        const CbxIncludeTaxSelector = '#cbx_include_tax'
        const InvoiceNumberSelector = '#invoice_number'
        const FreightSelector = '#total_freight_ex'
        const DutySelector = '#total_duty_ex'
        const MiscSelector = '#total_misc_ex'
        const ProductOrderIdSelector = '#tbxPOID'
        const RoundingAdjustmentSelector = '#rounding_adjustment'
        const InvoiceDateSelector = '#dp_invoice_date'
        const InvoiceDateInputSelector = InvoiceDateSelector + '_wrapper .rcTable .riTextBox'
        const InvoiceDateInputErrorClassName = 'riError'

        const DollarSign = '$'

        var self = {};
        self.IsIncludeTax = true
        self.TaxValue = 0
        self.TaxCoeficient = 0.1
        self.TotalSupplierBuy = 0
        self.InvoiceNumber = ''
        self.TotalFreightEx = 0
        self.TotalDutyEx = 0
        self.TotalMiscEx = 0
        self.RoundingAdjustment = 0
        self.SupplierInvoiceDate = ''
        self.CallBackFn = function () {
        }

        var calculate = function () {
            $(InvoiceNumberSelector).val(self.InvoiceNumber)
            $(CbxIncludeTaxSelector).get(0).checked = self.IsIncludeTax

            $(TotalSupplierBuyExTaxSelector).html(formatPrice(self.TotalSupplierBuy))
            $(TotalFreightExSelector).html(formatPrice(self.TotalFreightEx))
            $(TotalDutyExSelector).html(formatPrice(self.TotalDutyEx))
            $(TotalMiscExSelector).html(formatPrice(self.TotalMiscEx))
            $(TotalExSelector).html(formatPrice(self.TotalSupplierBuy + self.TotalFreightEx + self.TotalDutyEx + self.TotalMiscEx))
            $(TotalDutyTaxSelector).html(formatPrice(0))
            $(TotalDutyIncSelector).html(formatPrice(self.TotalDutyEx))

            if ($(RoundingAdjustmentSelector)) {
                $(RoundingAdjustmentSelector).val(formatPrice(self.RoundingAdjustment))
            }

            if (self.IsIncludeTax) {
                $(TotalSupplierBuyIncTaxSelector).html(formatPrice(self.TotalSupplierBuy + self.TotalSupplierBuy * self.TaxCoeficient))
                $(TotalFreightIncSelector).html(formatPrice(self.TotalFreightEx + self.TotalFreightEx * self.TaxCoeficient))
                $(TotalMiscIncSelector).html(formatPrice(self.TotalMiscEx + self.TotalMiscEx * self.TaxCoeficient))
                $(TotalIncSelector).html(formatPrice(calculateTotalIncSelector(self.TotalFreightEx, self.TotalDutyEx, self.TotalMiscEx, self.RoundingAdjustment)))

                $(TotalSupplierBuyTaxSelector).html(formatPrice(self.TaxValue))
                $(TotalFreightTaxSelector).html(formatPrice(self.TotalFreightEx * self.TaxCoeficient))
                $(TotalMiscTaxSelector).html(formatPrice(self.TotalMiscEx * self.TaxCoeficient))
                $(TotalTaxSelector).html(formatPrice((self.TotalSupplierBuy + self.TotalFreightEx + self.TotalMiscEx) * self.TaxCoeficient))
            }
            else {
                $(TotalSupplierBuyIncTaxSelector).html(formatPrice(self.TotalSupplierBuy))
                $(TotalFreightIncSelector).html(formatPrice(self.TotalFreightEx))
                $(TotalMiscIncSelector).html(formatPrice(self.TotalMiscEx))
                $(TotalIncSelector).html(formatPrice(calculateTotalIncSelector(self.TotalFreightEx, self.TotalDutyEx, self.TotalMiscEx, self.RoundingAdjustment)))

                $(TotalSupplierBuyTaxSelector).html(formatPrice(0))
                $(TotalFreightTaxSelector).html(formatPrice(0))
                $(TotalMiscTaxSelector).html(formatPrice(0))
                $(TotalTaxSelector).html(formatPrice(0))
            }
        }

        var formatPrice = function (price) {
            return DollarSign + price.toFixed(2);
        }

        var removeDollarSign = function (val) {
            if (val.indexOf(DollarSign) == 0) {
                return val.slice(1)
            }
            return val
        }

        var calculateTotalIncSelector = function(totalFreightEx, totalDutyEx, totalMiscEx, roundingAdjustment) {
            var totalInc;
            if (self.IsIncludeTax) {
                totalInc = ((self.TotalSupplierBuy + totalFreightEx+ totalDutyEx + totalMiscEx)
                    + (self.TotalSupplierBuy + totalFreightEx + totalMiscEx)
                    * self.TaxCoeficient) + roundingAdjustment
            }
            else {
                totalInc = self.TotalSupplierBuy + totalFreightEx + totalDutyEx + totalMiscEx + roundingAdjustment;
            }

            return totalInc;
        }


        var submitLegacy = function (e) {

            var submitUrl = window.location.origin + '/dotnet/admin/api/quickreceivestock'

            if (validateDirectCosts()) {
                if (window.confirm("You are about to update inventory. Are you sure you wish to proceed?")) {
                    BackOffice.ToggleLoader(true, 120000);
                    $.ajax({
                        method: 'POST',
                        data: JSON.stringify({
                            POId: $(ProductOrderIdSelector).val(),
                            SupplierInvoiceNumber: $(InvoiceNumberSelector).val() == '' ? null : $(InvoiceNumberSelector).val(),
                            IncludeTax: $(CbxIncludeTaxSelector).get(0).checked,
                            TotalFreightEx: self.TotalFreightEx,
                            TotalDutyEx: self.TotalDutyEx,
                            TotalMiscEx: self.TotalMiscEx,
                            RoundingAdjustment: self.RoundingAdjustment
                        }),
                        url: submitUrl,
                        dataType: 'json',
                        contentType: 'application/json charset=UTF-8',
                        success: function () {
                            $(ModalSelector).modal('hide')
                            if (self.CallBackFn) {
                                self.CallBackFn()
                            }
                        }
                    }).done(function () {
                        BackOffice.ToggleLoader(false);
                    });
                }
            }
            e.preventDefault()
            return false
            
        }

        var submit = function () {

            var submitUrl = window.location.origin + '/dotnet/admin/api/quickreceivestock'

            BackOffice.ToggleLoader(true, 120000);
            $.ajax({
                method: 'POST',
                data: JSON.stringify({
                    POId: $(ProductOrderIdSelector).val(),
                    SupplierInvoiceNumber: $(InvoiceNumberSelector).val() == '' ? null : $(InvoiceNumberSelector).val(),
                    IncludeTax: $(CbxIncludeTaxSelector).get(0).checked,
                    TotalFreightEx: self.TotalFreightEx,
                    TotalDutyEx: self.TotalDutyEx,
                    TotalMiscEx: self.TotalMiscEx,
                    RoundingAdjustment: self.RoundingAdjustment,
                    SupplierInvoicedOn: self.SupplierInvoiceDate == '' ? null : self.SupplierInvoiceDate
                }),
                url: submitUrl,
                dataType: 'json',
                contentType: 'application/json charset=UTF-8',
                success: function () {
                    $(ModalSelector).modal('hide')
                    if (self.CallBackFn) {
                        self.CallBackFn()
                    }
                }
            }).done(function () {
                BackOffice.ToggleLoader(false);
            });

            return false

        }

        var validateDirectCosts = function () {
            var msg = "";
            if (self.TotalDutyEx < 0 || self.TotalFreightEx < 0 || self.TotalMiscEx < 0 ) {
                msg += "Direct Costs cannot be less than $0.00\n";
            }
            if (calculateTotalIncSelector(self.TotalFreightEx, self.TotalDutyEx, self.TotalMiscEx, self.RoundingAdjustment) < 0) {
                msg += "Invoice Total cannot be less than $0.00";
            }

            if (msg) {
                alert(msg);
                return false;
            }
            return true;
        };

        var validateTotalInc = function (source, args) {
            var totalFreightEx = parseFloat($(FreightSelector).val());
            totalFreightEx = isNaN(totalFreightEx) ? 0 : totalFreightEx;

            var totalDutyEx = parseFloat($(DutySelector).val());
            totalDutyEx = isNaN(totalDutyEx) ? 0 : totalDutyEx;

            var totalMiscEx = parseFloat($(MiscSelector).val());
            totalMiscEx = isNaN(totalMiscEx) ? 0 : totalMiscEx;

            var roundingAdjustment = parseFloat($(RoundingAdjustmentSelector).val().match(/^\$?(-?\d*.\d*)$/)[1]);
            roundingAdjustment = isNaN(roundingAdjustment) ? 0 : roundingAdjustment;

            var totalInc = calculateTotalIncSelector(totalFreightEx, totalDutyEx, totalMiscEx, roundingAdjustment);
            if (totalInc < 0) {
                args.IsValid = false;
            }
            else {
                args.IsValid = true;
            }
        }

        var openModal = function (userHasPermission, isStockReceiptMFEEnabled, invoiceDateFFEnabled, callbackFn, poHasReceipts, silent) {
            if (userHasPermission) {
                if (!silent) {
                    BackOffice.ToggleLoader(true)
                }

                if (isStockReceiptMFEEnabled) {
                    SubmitBtnSelector += '_ff_on'
                }

                if (isStockReceiptMFEEnabled && invoiceDateFFEnabled) {
                    $(InvoiceDateSelector).val('')
                    $(SubmitBtnSelector).off('click').click(openConfirmationModal)
                    $(ConfirmationModalCancelBtnSelector).off('click').click(closeConfirmationModal)
                    $(ConfirmationModalSubmitBtnSelector).off('click').click(submitConfirmationModal)
                } else {
                    $(SubmitBtnSelector).off('click').click(submitLegacy)
                }

                $(CbxIncludeTaxSelector).off('change').change(function () {
                    self.IsIncludeTax = this.checked
                    calculate()
                })

                $(InvoiceNumberSelector).off('change').change(function () {
                    self.InvoiceNumber = this.value
                })

                $(FreightSelector).off('change').change(function () {
                    var val = parseFloat(removeDollarSign(this.value))
                    if (val) {
                        self.TotalFreightEx = val
                        this.value = formatPrice(val)
                    } else {
                        self.TotalFreightEx = 0
                        this.value = formatPrice(0)
                    }
                    calculate()
                })

                $(DutySelector).off('change').change(function () {
                    var val = parseFloat(removeDollarSign(this.value))
                    if (val) {
                        self.TotalDutyEx = val
                        this.value = formatPrice(val)
                    } else {
                        self.TotalDutyEx = 0
                        this.value = formatPrice(0)
                    }
                    calculate()
                })

                $(MiscSelector).off('change').change(function () {
                    var val = parseFloat(removeDollarSign(this.value))
                    if (val) {
                        self.TotalMiscEx = val
                        this.value = formatPrice(val)
                    }
                    else {
                        self.TotalMiscEx = 0
                        this.value = formatPrice(0)
                    }
                    calculate()
                })

                if ($(RoundingAdjustmentSelector)) {
                    $(RoundingAdjustmentSelector).off('change').change(function () {
                        var val = parseFloat(this.value)

                        if (val) {
                            self.RoundingAdjustment = val
                            this.value = val.toFixed(2)
                        }
                        else {
                            self.RoundingAdjustment = 0
                            this.value = formatPrice(0)
                        }
                        calculate()
                    })
                }

                if ($(InvoiceDateSelector)) {
                    $(InvoiceDateSelector).off('change').change(function () {
                        self.SupplierInvoiceDate = this.value
                    })
                }

                self.CallBackFn = callbackFn

                $.ajax({
                    data: { POId: $(ProductOrderIdSelector).val() },
                    url: window.location.origin + '/dotnet/admin/api/getposummary',
                    dataType: 'json',
                    contentType: 'application/json charset=UTF-8',
                    success: function (model) {
                        self.TotalSupplierBuy = model.totalSupplierBuy
                        self.IsIncludeTax = true
                        self.TaxValue = model.totalTaxValue
                        if (!poHasReceipts) {
                            self.InvoiceNumber = model.supplierInvoiceNumber
                        }
                        self.TaxCoeficient = model.taxRate
                        calculate()
                        $(ModalSelector).modal('show')
                        BackOffice.ToggleLoader(false)
                    }
                })
            }
            else {
                $(AccessDeniedModalSelector).modal('show')
            }
            return false
        }

        var openConfirmationModal = function (e) {
            e.preventDefault()

            if (validateDirectCosts()) {
                if ($(InvoiceNumberSelector).val() == '') {
                    $(ConfirmationSINumberWarningSelector).show();
                } else {
                    $(ConfirmationSINumberWarningSelector).hide();
                }
                if ($(InvoiceDateSelector).val() == '') {
                    $(ConfirmationSIDateWarningSelector).show();
                } else {
                    $(ConfirmationSIDateWarningSelector).hide();
                }

                $(ConfirmationModalSelector).modal('show')
            }
            
            return false
        }

        var closeConfirmationModal = function (e) {
            e.preventDefault()

            $(ConfirmationModalSelector).modal('hide')
            $(InvoiceDateInputSelector).focus()
        }

        var submitConfirmationModal = function (e) {
            e.preventDefault()

            if ($(InvoiceDateInputSelector).hasClass(InvoiceDateInputErrorClassName)) {
                $(ConfirmationModalSelector).modal('hide')
                $(InvoiceDateInputSelector).focus()
            } else {
                $(ConfirmationModalSelector).modal('hide')
                submit()
            }
        }

        $(ModalSelector).on("hidden.bs.modal", function () {
            $('.modal-backdrop').remove();
        });

        var closeModal = function () {
            $('.modal-backdrop').remove()
            $(ModalSelector).modal('hide')
            BackOffice.ToggleLoader(false)
        }

        return $.extend(poEdit.QuickReceiveModal, {
            OpenModal: openModal,
            CloseModal: closeModal,
            ValidateDirectCosts: validateDirectCosts,
            ValidateTotalInc: validateTotalInc
        })
    })()

    return poEdit.QuickReceiveModal
}